module.exports = __webpack_public_path__ + "img/1302295524.402dc054.jpg";